import { name } from "file-loader"

const scooping_regular_master = [
  {
    name: 'water-smell-indicators',
    icon: 'pushpin-line'
  },
  {
    name: 'water-source-color-conditions',
    icon: 'pushpin-line'
  },
  {
    name: 'water-source-usages',
    icon: 'pushpin-line'
  },
  {
    name: 'water-source-availability-status',
    icon: 'pushpin-line'
  },
  {
    name: 'government-forestry-activity-schemas',
    icon: 'pushpin-line'
  },
  {
    name: 'government-forestry-objective-fields',
    icon: 'pushpin-line'
  },
  {
    name: 'community-institutions',
    icon: 'pushpin-line'
  },
  {
    name: 'educational-degrees',
    icon: 'pushpin-line'
  },
  {
    name: 'educational-facilities',
    icon: 'pushpin-line'
  },
  {
    name: 'healthcare-facilities',
    icon: 'pushpin-line'
  },
  {
    name: 'ispu-air-qualities',
    icon: 'pushpin-line'
  },
  {
    name: 'transportation-routes',
    icon: 'pushpin-line'
  },
  {
    name: 'transportations',
    icon: 'pushpin-line'
  },
  {
    name: 'forest-conservation-areas',
    icon: 'pushpin-line'
  },
  {
    name: 'land-usages',
    icon: 'pushpin-line'
  },
  {
    name: 'temperature-zone',
    icon: 'pushpin-line'
  },
  {
    name: 'yearly-rain-densities',
    icon: 'pushpin-line'
  },
  {
    name: 'rainfall-based-seasons',
    icon: 'pushpin-line'
  },
  {
    name: 'morphographies',
    icon: 'pushpin-line'
  },
  {
    name: 'slope-ranges',
    icon: 'pushpin-line'
  },
  {
    name: 'coverage-types',
    icon: 'pushpin-line'
  },
  {
    name: 'typographies',
    icon: 'pushpin-line'
  },
  {
    name: 'village-altitudes',
    icon: 'pushpin-line'
  },
  {
    name: 'village-potential-categories',
    icon: 'pushpin-line'
  },
  {
    name: 'village-residence-land-usages',
    icon: 'pushpin-line'
  },
  {
    name: 'village-planting-densities',
    icon: 'pushpin-line'
  },
  {
    name: 'village-commodities',
    icon: 'pushpin-line'
  },
  {
    name: 'village-classifications',
    icon: 'pushpin-line'
  },
]

const areas = [
  'provinces',
  'cities',
  'districts',
  'villages'
]
const biota = [
  {
    name: 'trees',
    icon: 'plant'
  },
  {
    name: 'fishs',
    icon: 'water-flash'
  },
  {
    name: 'farm-animals',
    icon: 'gitlab'
  },
]
const plantingPattern = [
  {
    parent_path: 'planting-patterns',
    name: 'planting-pattern-categories',
    icon: 'plant'
  },
  {
    parent_path: 'projects',
    name: 'planting-patterns',
    icon: 'node-tree'
  },
  {
    parent_path: 'planting-patterns',
    name: 'tree-model-harvest-types',
    icon: 'node-tree'
  },
  {
    parent_path: 'planting-patterns',
    name: 'planting-pattern-limitations',
    icon: 'plant'
  },
]
const projects = [
  {
    name: 'project-type',
    icon: 'file-settings'
  },
  {
    name: 'project-purpose',
    icon: 'send-plane-2'
  },
  {
    name: 'planting-environment',
    icon: 'repeat-2-fill'
  },
  {
    name: 'lahan-cover-types',
    icon: 'landscape'
  },
  {
    name: 'cultivation-types',
    icon: 'shuffle'
  },
  {
    name: 'lahan-status',
    icon: 'book-3'
  },
  {
    name: 'lahan-types',
    icon: 'survey'
  },
  {
    name: 'soil-types',
    icon: 'recycle'
  },
  {
    name: 'water-sources',
    icon: 'drop-line'
  },
  {
    name: 'electricity-sources',
    icon: 'flashlight-line'
  },
  {
    name: 'government-place-types',
    icon: 'government-line'
  },
  {
    name: 'legal-land-categories',
    icon: 'reserved'
  },
  {
    name: 'planting-types',
    icon: 'plant'
  },
  {
    name: 'farmer-groups',
    icon: 'team-line'
  },
  {
    name: 'business-entities',
    icon: 'user-community-line'
  },
  {
    name: 'training-materials',
    icon: 'presentation-line'
  },
]
const optionsSection = [
  'tree-categories',
  'fertilizers',
  'pesticides',
  'legals',
  'business-types',
  'lahan-uses',
  'land-coverage-types',
  'rt-relationships',
  'economic-activities',
  'lahan-ownerships',
  'irrigations',
  'tree-conditions',
  'harvest-systems',
  'smaller-harvest-areas',
  'production-uses',
  'livestock-groups',
  'livestock-feed-types',
  'production-types',
  'livestock-purposes',
  'wood-harvest-types',
  'wood-production-types',
  'uoms',
  'cultivation-activity-types',
  'receptacle-types',
  'cultivation-systems',
  'cultivation-technologies',
]
const positionRoles = [
  {
    name: 'jobs',
    icon: 'briefcase-2'
  },
  {
    name: 'role-groups',
    icon: 'map-pin-user'
  },
  {
    name: 'roles',
    icon: 'briefcase-2'
  },
]

const module = {
  config: {
    name: "Master",
    icon: "database-2",
    desc: "Data acuan utama pada Aplikasi, informasi Data Utama",
    layout: true,
    order: 5
  },
  routes: [
    // AREA
    {
      name: 'area',
      type: 'parent',
      // icon: "user",
      redirectName: 'provinces',
      child: [
        ...areas.flatMap(v => {
          return {
            name: v,
            icon: "map-pin",
            path: `/${v}`,
            translate_key: v,
            component: () => import(`./areas/${v}.vue`),
            separator: null
          }
        }),
      ]
    },
    // Biota
    {
      name: 'biota',
      type: 'parent',
      // icon: "user",
      redirectName: 'trees',
      child: [
        ...biota.flatMap(v => {
          return {
            name: v.name,
            icon: v.icon,
            path: `/${v.name}`,
            translate_key: v.name,
            component: () => import(`./${v.name}/${v.name}.vue`),
            separator: null
          }
        }),
      ]
    },
    // Suku
    {
        name: "ethnic",
        icon: "user-location",
        path: `/ethnic`,
        translate_key: "ethnic",
        component: () => import(`./ethnic/ethnic.vue`),
        separator: ""
    },
    // // Plant Library
    // {
    //     name: "trees",
    //     icon: "plant",
    //     path: `/trees`,
    //     translate_key: "trees",
    //     component: () => import(`./trees/trees.vue`),
    //     separator: ""
    // },
    // // Perikanan
    // {
    //     name: "fishs",
    //     icon: "water-flash",
    //     path: `/fishs`,
    //     translate_key: "fishs",
    //     component: () => import(`./fishs/fishs.vue`),
    //     separator: ""
    // },
    // Lokasi Persemaian
    {
        name: "nursery-locations",
        icon: "landscape",
        path: `/nursery-locations`,
        translate_key: "nursery-locations",
        component: () => import(`./nursery-locations/nursery-locations.vue`),
        separator: ""
    },
    // Planting Pattern
    {
      name: 'planting-pattern',
      type: 'parent',
      // icon: "user",
      redirectName: 'planting-patterns',
      child: [
        ...plantingPattern.flatMap(v => {
          return {
            name: v.name,
            icon: v.icon,
            path: `/${v.name}`,
            translate_key: v.name,
            component: () => import(`./${v.parent_path}/${v.name}.vue`),
            separator: null
          }
        }),
      ]
    },
    // PROJECT
    {
      name: 'project',
      type: 'parent',
      // icon: "user",
      redirectName: 'projects',
      child: [
        ...projects.flatMap(v => {
          return {
            name: v.name,
            icon: v.icon,
            path: `/${v.name}`,
            translate_key: v.name,
            component: () => import(`./projects/${v.name}.vue`),
            separator: null
          }
        }),
      ]
    },
    
    // POSITION ROLES
    {
      name: 'position-roles',
      type: 'parent',
      // icon: "user",
      redirectName: 'role-groups',
      child: [
        ...positionRoles.flatMap(v => {
          return {
            name: v.name,
            icon: v.icon,
            path: `/${v.name}`,
            translate_key: v.name,
            component: () => import(`./position-roles/${v.name}.vue`),
            separator: null
          }
        }),
      ]
    },
    // OPTIONS SECTION
    {
      name: 'options-section',
      type: 'parent',
      // icon: "user",
      redirectName: 'fertilizers',
      child: [
        ...optionsSection.flatMap(v => {
          return {
            name: v,
            icon: "arrow-right-s-fill",
            path: `/${v}`,
            translate_key: v,
            component: () => import(`./options-section/${v}.vue`),
            separator: null
          }
        }),
      ]
    },
    // user-activity-type
    {
        name: "user-activity-type",
        icon: "contacts",
        path: `/user-activity-type`,
        translate_key: "user-activity-type",
        component: () => import(`./user-activity-type/user-activity-type.vue`),
        separator: ""
    },
    // task-groups
    {
        name: "task-groups",
        icon: "list-settings",
        path: `/task-groups`,
        translate_key: "task-groups",
        component: () => import(`./tasks/task-groups.vue`),
        separator: ""
    },
    // user-activities
    {
        name: "user-activities",
        icon: "share",
        path: `/user-activities`,
        translate_key: "user-activities",
        component: () => import(`./user-activities/user-activities.vue`),
        separator: ""
    },
    // configs
    {
        name: "configs",
        icon: "settings-3",
        path: `/configs`,
        translate_key: "configs",
        component: () => import(`./configs/configs.vue`),
        separator: ""
    },
    // activity based masters
    //regular scooping visits
    {
      name: 'regular-scooping-visits-master-data',
      type: 'parent',
      // icon: "user",
      redirectName: 'role-groups',
      child: [
        ...scooping_regular_master.flatMap(v => {
          return {
            name: v.name,
            icon: v.icon,
            path: `/${v.name}`,
            translate_key: v.name,
            component: () => import(`./activity-based-master/scooping-regular/${v.name}.vue`),
            separator: null
          }
        }),
      ]
    },
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/masters/_index.js